import fitty from "fitty";
import { getParentByClass } from "../../../resources/js/helper/helper";

(function () {
  // On document ready
  docReady(function (context) {
    const fitHeadlines = document.querySelectorAll(".mb-fittext");
    for (let i = 0; i < fitHeadlines.length; i++) {
      fitty(fitHeadlines[i]);
      repeatMobileHeadline(fitHeadlines[i]);
    }

    // break and repeat fitting headlines on mobile devices
    window.addEventListener("resize", (event) => {
      for (let i = 0; i < fitHeadlines.length; i++) {
        repeatMobileHeadline(fitHeadlines[i]);
      }
    });
  });
})();

/**
 * break and repeat fitting headlines on mobile devices
 * @param {DOM} headline
 * @returns
 */
function repeatMobileHeadline(headline) {
  const headlineWrapper = getParentByClass(headline, "com-headline__wrapper");
  if (!headlineWrapper || !headline) return;

  // remove all current headline repeater
  headlineWrapper
    .querySelectorAll(".headline-repeater")
    .forEach((e) => e.parentNode.removeChild(e));

  // get repeat factor
  const factor = Math.floor(headline.offsetWidth / window.innerWidth);

  // get current headline infos
  const classList = headline.classList;
  const headlineText = headline.innerHTML;

  // exclude from google indexing
  const googleOff = "<!--googleoff: index-->";
  const googleOn = "<!--googleon: index-->";

  let repeatHeadline = null;

  // add headline repeater
  let n = 0;
  while (n < factor) {
    n++;
    repeatHeadline = document.createElement("span");
    repeatHeadline.classList = classList;
    repeatHeadline.classList.add("h1", "headline-repeater");
    repeatHeadline.innerHTML = googleOff + headlineText + googleOn;
    repeatHeadline.style.transform = "translateX(-" + n * 100 + "vw)";
    headlineWrapper.appendChild(repeatHeadline);
  }
}
